import axios from "axios";
import FileDownload from "js-file-download";
import constants from "../../utils/constants";
import { errorNotification } from "../../utils/notifications";

const EMPLOYEES_REPORT_BASE_URL = "/api/reports";
const TOTAL_PASS_BASE_URL = "/api/total-pass";

export const getEmployeesReport = (queryParams: any) => {
  const url = `${constants.BASE_URL}${EMPLOYEES_REPORT_BASE_URL}/report-employees`;
  const config = { withCredentials: true, params: queryParams };
  return axios.get(url, config);
};

export const getEmployeesReportCsv = (queryParams: any, callback: any) => {
  return axios
    .get(
      `${constants.BASE_URL}${EMPLOYEES_REPORT_BASE_URL}/report-employees/download`,
      {
        withCredentials: true,
        responseType: "blob",
        params: queryParams
      }
    )
    .then(({ data }) => {
      FileDownload(data, `ReporteEmpleados.csv`);
      callback && callback();
    })
    .catch(error => {
      errorNotification("No se pudo descargar el reporte");
      callback && callback(error);
    });
};

export const getEmpleadoAsistencias = idPersona => {
  const url = `${constants.BASE_URL}${TOTAL_PASS_BASE_URL}/${idPersona}/asistencias`;
  const config = { withCredentials: true };
  return axios.get(url, config);
};
